module.exports = __webpack_public_path__ + "img/trafficgeneration.c0fb54b7.jpg";